module.exports = __webpack_public_path__ + "static/media/hab6-0.28b8f09a.jpg";